import jApi from './jApi';

export default {
  // Data Group
  listDataGroup(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/joana/datasetgroup/fetch', req)
      .then(res => res.data);
  },

  createDataGroup(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/joana/datasetgroup/create', req)
      .then(res => res.data);
  },

  updateDataGroup(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/joana/datasetgroup/update', req)
      .then(res => res.data);
  },

  deleteDataGroup(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/joana/datasetgroup/delete', { params })
      .then(res => res.data);
  },

  // Dataset
  listDatasetByGroup(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/joana/dataset/fetch', req)
      .then(res => res.data);
  },

  createDatasetByGroup(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/joana/dataset/create', req)
      .then(res => res.data);
  },

  deleteDatasetByGroup(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/joana/dataset/delete', { params })
      .then(res => res.data);
  },

  truncateDatasetByGroup(req) {
    const api = jApi.generateApi();
    return api.post(`/nocode/joana/dataset/record/truncate?dataset_id=${req.dataset_id}`)
      .then(res => res.data);
  },

  detailDatasetByGroup(params) {
    const api = jApi.generateApi();
    return api.get('/nocode/joana/dataset/get', { params })
      .then(res => res.data);
  },

  addColumnDataset(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/joana/dataset/column/add', req.data)
      .then(res => res.data);
  },

  updateColumnDataset(req) {
    const api = jApi.generateApi();
    return api.post(`/nocode/joana/dataset/column/update?name=${req.name}`, req.data)
      .then(res => res.data);
  },

  deleteColumnDataset(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/joana/dataset/column/delete', { params })
      .then(res => res.data);
  },

  getListRecordByDatasetId(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/joana/dataset/record/fetch', req)
      .then(res => res);
  },

  getCountRecordByDatasetId(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/joana/dataset/record/count', req)
      .then(res => res);
  },

  createRecordDataset(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/joana/dataset/record/create', req)
      .then(res => res.data);
  },

  updateRecordDataset(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/joana/dataset/record/update', req)
      .then(res => res.data);
  },

  deleteRecordDataset(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/joana/dataset/record/delete', { params })
      .then(res => res.data);
  },

  listQuery(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/joana/dataset/query/fetch', req)
      .then(res => res.data);
  },

  runQuery(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/joana/dataset/query/run', req)
      .then(res => res.data);
  },

  createQuery(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/joana/dataset/query/create', req)
      .then(res => res.data);
  },

  updateQuery(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/joana/dataset/query/update', req)
      .then(res => res.data);
  },

  deleteQuery(params) {
    const api = jApi.generateApi();
    return api.delete('/nocode/joana/dataset/query/delete', { params })
      .then(res => res.data);
  },

  saveResultQuery(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/joana/dataset/query/save-result', req)
      .then(res => res.data);
  },

  setPrimaryKey(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/joana/dataset/column/set-primarykey', req)
      .then(res => res.data);
  },

  removePrimaryKey(req) {
    const api = jApi.generateApi();
    return api.post('/nocode/joana/dataset/column/remove-primarykey', req)
      .then(res => res.data);
  },

  // Indexes
  getIndexList(id) {
    const api = jApi.generateApi();
    return api.get(`indexing/joana/${id}/indexes`)
      .then(res => res.data);
  },

  setIndexes(payload) {
    const api = jApi.generateApi();
    return api.post(`indexing/joana/${payload.id}/indexes`, payload.payload)
      .then(res => res.data);
  },

  getRequestOtp(id) {
    const api = jApi.generateApi();
    return api.get(`indexing/joana/${id}/indexes/request-otp`)
      .then(res => res.data);
  },

  removeIndexes(payload) {
    const api = jApi.generateApi();
    return api.delete(`indexing/joana/${payload.id}/indexes/${payload.name}`, { data: payload.payload })
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiJoana.js